import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

export const EmailFooterSelector = (props) => {
    const { footers, selectedFooter, onFooterChange } = props;
    const { t } = useTranslation();

    const inputLabelId = "email-footer-select-label";

    return (
        <FormControl fullWidth>
            <InputLabel id={inputLabelId}>
                {t("sellers.EmailFooterSelector.selectedFooter") + "*"}
            </InputLabel>
            <Select
                labelId={inputLabelId}
                value={selectedFooter?.id || ""}
                label={t("sellers.EmailFooterSelector.selectedFooter")}
                onChange={(event) => {
                    const footerId = event.target.value;
                    const footer = footers.find((f) => f.id === footerId) || null;
                    onFooterChange(footer);
                }}
            >
                {footers.map((footer) => (
                    <MenuItem key={footer.id} value={footer.id}>
                        {footer.name}
                    </MenuItem>
                ))}
                <MenuItem value="none">-</MenuItem>
            </Select>
        </FormControl>
    );
};
